(function () {
    'use strict';

    angular
        .module('core.directives')
        .directive('sidebar', Sidebar)

    /** @ngInject */
    function Sidebar($window, $rootScope, $timeout, $state, AuthenticationService, ImagePathHelper, PATHS, LOCAL_STORAGE_ITEMS, DATA_EVENTS) {
        function SidebarController($scope) {
            const vm = this;
            let preventActiveCheckUpdate = false;

            vm.toggleMenuOpen = () => {
                vm.menuOpen = !vm.menuOpen;

                $rootScope.menuOpen = vm.menuOpen;

                localStorage.setItem(LOCAL_STORAGE_ITEMS.MENU, vm.menuOpen);
            }

            vm.handleSubmodule = module => {
                if (!module.ParentModuleId) {
                    if (!module.IsOpen) {
                        vm.modules.forEach(mod => {
                            mod.IsOpen = false;
                        });

                        if (module.Module1.length)
                            module.IsOpen = true;
                    } else
                        module.IsOpen = false;

                    preventActiveCheckUpdate = true;
                }
            }

            vm.getState = module => {
                if (module.Module1 && module.Module1.length)
                    return 'null';

                let state = $state.get().find(state => (state.url == module.Url));

                return state ? state.name : 'app.home';
            }

            vm.isActiveMenu = module => {
                if (module.ParentModuleId) {
                    let currentUrl = $window.location.pathname.replace(/\d/g, '').replace(/\/$/, '').replace('/new', '');

                    if (currentUrl == module.Url && module.Module1 && module.Module1.length && !preventActiveCheckUpdate)
                        module.IsOpen = true;

                    return currentUrl == module.Url;
                }

                if (module.Id == $state.current.moduleId && module.Module1 && module.Module1.length && !preventActiveCheckUpdate)
                    module.IsOpen = true;

                return module.Id == $state.current.moduleId;
            }

            vm.getPersonImage = () => {
                if (vm.loggedUserData.Image)
                    return ImagePathHelper.imageResizePath('person', vm.loggedUserData.Id, vm.loggedUserData.Image, 150, 150);

                return '/api/images/res/150/150/placeholder.jpg';
            }

            let removeWatchUnit = $rootScope.$on(DATA_EVENTS.SELECTED_COMPANY_CHANGE, () => {
                vm.modules = [];

                init();
            })

            let removeWatchUser = $rootScope.$on(DATA_EVENTS.USER_UPDATED, () => {
                vm.loggedUserData = AuthenticationService.getUser();
            })

            $scope.$on('$destroy', () => {
                removeWatchUnit();
                removeWatchUser();
            })

            init();

            function compareMenuTitle(a, b) {
                if (a.Title < b.Title)
                    return -1;

                if (a.Title > b.Title)
                    return 1;

                return 0;
            }

            function setFirstRunCurrentModule() {
                let currentStateUrl = $state.current.url;

                if (currentStateUrl.split('/').length > 2)
                    currentStateUrl = `/${currentStateUrl.split('/')[1]}`

                let currentModule = vm.modules.find(mod => (currentStateUrl == mod.Url));

                if (!currentModule) {
                    vm.modules.forEach(mod => {
                        if (mod.Module1 && mod.Module1.length && mod.Module1.find(subMod => subMod.Url == currentStateUrl)) {
                            currentModule = mod;
                        }
                    })
                }

                if (currentModule)
                    currentModule.IsOpen = true;
            }

            function init() {
                vm.logout = AuthenticationService.logout;
                vm.loggedUserData = AuthenticationService.getUser();
                vm.isMobile = $rootScope.isMobile;

                const lsValue = localStorage.getItem(LOCAL_STORAGE_ITEMS.MENU);
                let isMenuOpen = true;

                if (lsValue == 'false' || lsValue == false || $rootScope.isMobile)
                    isMenuOpen = false;

                $timeout(() => {
                    vm.menuOpen = isMenuOpen;
                    $rootScope.menuOpen = isMenuOpen;

                    $.fn.scrollbar && $('.scrollable').scrollbar({
                        ignoreOverlay: false
                    });

                    vm.modules = AuthenticationService.getPermissions().sort(compareMenuTitle);
                    vm.modules
                        .filter(module => module.Module1 && module.Module1.length)
                        .map(module => module.Module1.sort(compareMenuTitle));

                    setFirstRunCurrentModule();
                })
            }
        }

        return {
            bindToController: true,
            controller: SidebarController,
            controllerAs: 'vm',
            restrict: 'AE',
            templateUrl: `${PATHS.PHYSICAL}/directives/sidebar/sidebar.html`,
            scope: {}
        }
    }
}());